var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge01PlusFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 20,
    viewBox: "0 0 43 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H39C41.2091 0 43 1.79086 43 4V16C43 18.2091 41.2091 20 39 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#8D35C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 15.6C13.0927 15.6 15.5999 13.0928 15.5999 9.99999C15.5999 6.9072 13.0927 4.39999 9.9999 4.39999C6.90711 4.39999 4.3999 6.9072 4.3999 9.99999C4.3999 13.0928 6.90711 15.6 9.9999 15.6ZM10.6999 7.89999C10.6999 7.51339 10.3865 7.19999 9.9999 7.19999C9.6133 7.19999 9.2999 7.51339 9.2999 7.89999V9.29999H7.8999C7.5133 9.29999 7.1999 9.61339 7.1999 9.99999C7.1999 10.3866 7.5133 10.7 7.8999 10.7H9.2999V12.1C9.2999 12.4866 9.6133 12.8 9.9999 12.8C10.3865 12.8 10.6999 12.4866 10.6999 12.1V10.7H12.0999C12.4865 10.7 12.7999 10.3866 12.7999 9.99999C12.7999 9.61339 12.4865 9.29999 12.0999 9.29999H10.6999V7.89999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2953 10.3789V11.5742H24.1234V15.0664H22.6469V11.5742H18.5336V10.3789H28.2953ZM19.682 9.23047V4.92969H27.1234V9.23047H19.682ZM21.1586 8.05859H25.6352V6.11328H21.1586V8.05859ZM38.4781 12.6641V13.8945H28.7164V12.6641H31.2125V11.0352H29.8414V7.44922H35.8766V6.30078H29.8297V5.10547H37.3531V8.64453H31.3414V9.82812H37.5992V11.0352H36.0875V12.6641H38.4781ZM32.6656 12.6641H34.6227V11.0352H32.6656V12.6641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge01PlusFree);
export default __webpack_public_path__ + "static/media/badge_01_plus_free.10984b408f0c4d0df6f3b230bcd37cca.svg";
export { ForwardRef as ReactComponent };